




























































import { CreditcardServiceForPurchase } from '@/services/api/creditcard'
import { Mixins } from 'vue-mixin-decorator'
import { Component } from 'vue-property-decorator'

import LoadingMixin, { Status } from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'

import { getCreditcardPaymentProvierServiceConfig } from '@/services/payment'
import { User } from '@spa/store/modules/user/types'

import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import CreditcardForm from '@spa/components/organisms/payment/creditcard/CreditcardForm.vue'
import { CreditcardFormState } from '@spa/components/organisms/payment/creditcard/creditcardFormState'
import SpaCreditCardDescription from '@spa/components/organisms/payment/description/CreditCardDescription.vue'

import { none } from 'fp-ts/lib/Option'

@Component({
  components: {
    SpaErrorDialog,
    SpaCreditCardDescription,
    CreditcardForm,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class ReorderCreditcard extends Mixins<PluginMixin>(PluginMixin) {
  status: Status = Status.Pending
  showModal: boolean = false
  modalMessage: string = ''

  formState: CreditcardFormState = {
    cardNumber: '',
    cardOwner: '',
    expireMonth: '',
    expireYear: '',
    securityCode: '',
  }

  creditcardService = new CreditcardServiceForPurchase()

  readonly cardPaymentProvider = getCreditcardPaymentProvierServiceConfig().forPurchase

  get isLoading() {
    return this.status === Status.Loading
  }

  get orderId(): string {
    const { id } = this.$route.params

    return id
  }

  get cancelUrl(): string {
    return `/mypage/order/${this.orderId}/reorder/payment`
  }

  get user(): User {
    return this.$store.state.user.user
  }

  async validateAll(): Promise<boolean> {
    return this.$validator.validateAll()
  }

  async initUser(): Promise<void> {
    await this.$store.dispatch('user/get')
  }

  async loadCreditcardScript() {
    const errorMessage: string = 'エラーが発生しました。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
    await this.cardPaymentProvider.loadScript()
      .catch(() => {
        this.modalMessage = errorMessage
        this.showModal = true
      })
  }

  async created() {
    await Promise.all([
      this.initUser(),
      this.loadCreditcardScript(),
    ])
  }

  onCardNumberChange(value: string): void {
    this.formState.cardNumber = value
  }

  onCardOwnerChange(value: string): void {
    this.formState.cardOwner = value
  }

  onExpireMonthChange(value: string): void {
    this.formState.expireMonth = value
  }

  onExpireYearChange(value: string): void {
    this.formState.expireYear = value
  }

  onSecurityCodeChange(value: string): void {
    this.formState.securityCode = value
  }

  async submit() {
    if (this.status === Status.Loading) {
      return
    }

    this.status = Status.Loading

    const validated = await this.validateAll()

    if (!validated) {
      this.modalMessage = '入力内容が正しくありません'
      this.showModal = true
      this.status = Status.Failed

      return
    }

    const paymentResult = await this.cardPaymentProvider.createRegisterCardPayload(
      this.formState,
      this.user
    )

    if (paymentResult.isLeft()) {
      this.modalMessage = 'クレジットカード情報が認証できませんでした。<br/>入力内容に誤りがないかご確認お願いします。'
      this.showModal = true

      this.status = Status.Failed

      return
    }

    const token = paymentResult.value

    /**
     * サブスクではなく商品購入（再決済含む）用のカードについては、登録時は3Dセキュアでないことを強い前提として置いてよいため、リダイレクト先も予めnoneにしておく。
     * 型ないし設定値でそうした制約が判定できることが望ましい。
     */
    /**
     * APIサービス層を直接呼ぶのではなくユースケース層を経由した方がよい。
     */
    const result = await this.creditcardService.create(token, none, none)

    if (result.isLeft()) {
      this.modalMessage = this.getErrorMessage(result)
      this.showModal = true

      this.status = Status.Failed

      return
    }

    await this.$store.dispatch('creditcard/load', { force: true })

    this.status = Status.Completed
    this.navigateToPaymentPage()
  }

  private navigateToPaymentPage() {
    this.$router.push(`/mypage/order/${this.orderId}/reorder/payment`)
  }

  private getErrorMessage(result) {
    const errorBody = result.value.response.body

    switch (errorBody['message']) {
      case 'invalid_card':
        return '無効なカード番号です。お手元のカード番号をご確認の上、正しい番号を入力してください。'
      default:
        return 'クレジットカードが登録できませんでした。'
    }
  }
}
